module.exports = __webpack_public_path__ + "media/images/lp/1/plight6-sp-f948e56abba2565e44d81211512d5a2c.png";